// extracted by mini-css-extract-plugin
export var container = "toolbar-module--container--80454";
export var content = "toolbar-module--content--350e3";
export var icon = "toolbar-module--icon--d5c87";
export var row = "toolbar-module--row--a6c9b";
export var text = "toolbar-module--text--46f64";
export var toolbar = "toolbar-module--toolbar--8e6fd";